import type { IMessageIllustration } from './MessageIllustration';

import MessageIllustration from './MessageIllustration';

export type { IMessageIllustration };
export default MessageIllustration;
